interface CoordinateDisplayProps {
  lat: number | null;
  lng: number | null;
  onPickLocation: () => void;
  label?: string;
}

export function CoordinateDisplay({
  lat,
  lng,
  onPickLocation,
  label = 'Location',
}: CoordinateDisplayProps) {
  const hasCoords = lat !== null && lng !== null;

  return (
    <div className="flex flex-col gap-1.5">
      <span className="field-label">
        {label} <span className="text-[var(--color-accent)]">*</span>
      </span>

      <div className="flex items-center justify-between gap-3 px-3 py-2.5 rounded-md bg-[var(--color-elevated)] border border-[var(--color-border)]">
        {hasCoords ? (
          <>
            <span className="flex items-center gap-2 text-body-sm text-[var(--color-text-primary)] tabular-nums min-w-0">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="shrink-0 text-[var(--color-accent)]"
                aria-hidden="true"
              >
                <path
                  d="M7 0C4.243 0 2 2.243 2 5c0 3.75 5 9 5 9s5-5.25 5-9c0-2.757-2.243-5-5-5zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
                  fill="currentColor"
                />
              </svg>
              <span className="truncate">
                {lat.toFixed(6)}, {lng.toFixed(6)}
              </span>
            </span>
            <button
              type="button"
              onClick={onPickLocation}
              className="text-body-sm text-[var(--color-accent)] hover:opacity-80 transition-opacity shrink-0"
              aria-label="Change location on map"
            >
              Change
            </button>
          </>
        ) : (
          <>
            <span className="text-body-sm text-[var(--color-text-muted)]">No location set</span>
            <button
              type="button"
              onClick={onPickLocation}
              className="text-body-sm font-medium text-[var(--color-accent)] border border-[var(--color-accent)] rounded px-2.5 py-1 hover:bg-[var(--color-accent)]/10 transition-colors shrink-0"
              aria-label="Pick location on map"
            >
              Pick on Map
            </button>
          </>
        )}
      </div>
    </div>
  );
}
